import { css, styled } from "@mui/material";

import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const ProjectsSeeAlsoHeader = styled("p")(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
    ${cssForHeaderWithLinearGradient(theme)}
  `,
);

export const ProjectsSeeAlsoSubheader = styled("p")(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.paragraph_medium_regular)}
  `,
);

export const ProjectsSeeAlsoContainer = styled("div")(
  ({ theme }) => css`
    display: flex;

    ${theme.breakpoints.up("mobile")} {
      flex-direction: column;
      gap: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      flex-direction: row;
      gap: 24px;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 32px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      gap: 40px;
    }
  `,
);
